<template>
    <div class="DshBack">
        <Button
            :type="propsObj.btnType"
            :size="propsObj.size || 'small'"
            @click="clickBack"
        >返回</Button>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "DshBack",
        mixins: [controlMixin],
        props: {},
        data () {
            return {

            };
        },
        computed: {
            modForm () {
                return this.propsObj.modForm;
            }
        },
        created () {},
        methods: {
            // 字段 -点击返回
            clickBack (operationItem, formItem, formIndex) {
                this.$emit("changeField", this.modForm.find(formItem => formItem._key === this.value[this.propsObj._key]), null, null);
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshBack {

    }
</style>
<style lang="less">
    .DshBack {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshBack.vue